module.exports = __webpack_public_path__ + "static/media/Slakoth_gaussian2.98867695.png";